// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"76":"common","612":"user-refunds","945":"dashboard"}[chunkId] + "." + {"76":"28a4d8f0","612":"31036ddd","945":"edd6bbc1"}[chunkId] + ".css";
};